import RewardList from "./RewardList";
import RewardIcon from "@mui/icons-material/Redeem";

const rewards = {
  list: RewardList,
  icon: RewardIcon,
};

export default rewards;
